<script></script>

<div class="Header"><h1>🐙 Tiia Aurora 🐙</h1></div>

<style>
    h1 {
        font-family: "IM Fell English SC", serif;
        color: rgb(233, 107, 24);
        text-transform: uppercase;
        font-size: 3em;
        font-weight: bolder;
        font-weight: 100;
        text-align: center;
        text-shadow: 3px 3px 8px black;
    }

    div.Header {
        background-color: #222;
    }

    @media (orientation: portrait) {
        h1 {
            font-size: 2em;
        }
    }
</style>
